import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data);
    } catch (e) {
      console.error("content load failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (content?.seo) {
      document.title = content.seo.title || "Salty Folks";
      const meta = document.querySelector('meta[name="description"]');
      if (meta && content.seo.description) meta.setAttribute("content", content.seo.description);
    }
  }, [content]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh, setContent }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
